<template>
  <el-select
    v-model="userId"
    ref="kfRef"
    :loading="isLoading"
    size="small"
    :clearable="clearable"
    @clear="onClear"
    :disabled="disable"
    filterable
    remote
    :remote-method="getList"
    placeholder="请选择"
  >
    <el-option
      v-for="item in list"
      :label="item.userName"
      :value="item.id"
      :key="item.id"
    />
  </el-select>
</template>

<script>
import { getUserListAPI } from "./api.js";

export default {
  name: "SelectKf",

  props: {
    value: {
      type: [String, Number],
      default: "input",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    userId: {
      get() {
        return this.value > 0 ? this.value : undefined;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },

  data() {
    return {
      list: [],
      isLoading: false,
    }
  },

  created() {
    this.getList('');
  },

  methods: {
    async getList(query) {
      let params = {
        page: 1,
        pageSize: 50,
        userName: query,
      };
      this.list = await getUserListAPI(params);
    },

    close() {
      this.getList('');
      this.$refs.kfRef.blur();
    },

    onClear() {
      this.getList('');
      this.$refs.kfRef.blur();
    },
  }
}
</script>
